import apiClient from "./api";

export interface Biller {
  id?: number;
  code: string;
  name: string;
  image?: string;
  email?: string;
  phone?: string;
  country?: string;
  status?: number;
}

const billerService = {
  async getBillers(params?: any): Promise<Biller[]> {
    const response = await apiClient.get("/billers", { params });
    return response.data.data ?? response.data;
  },
  async getBiller(id: number): Promise<Biller> {
    const response = await apiClient.get(`/billers/${id}`);
    return response.data;
  },
  async createBiller(input: Biller): Promise<Biller> {
    const response = await apiClient.post("/billers", input);
    return response.data.data ?? response.data;
  },
  async updateBiller(id: number, input: Partial<Biller>): Promise<Biller> {
    const response = await apiClient.put(`/billers/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteBiller(id: number): Promise<void> {
    await apiClient.delete(`/billers/${id}`);
  },
};

export default billerService;
